import React, { useState } from "react";
import { globals } from "../globals";

const Ingest = () => {
  const [mode, setMode] = useState("normal"); // "normal" o "integrated"
  const [watermark, setWatermark] = useState("true");
  const [ingestStatus, setIngestStatus] = useState(""); // Stato del processo di ingest
  const [progress, setProgress] = useState(0); // Percentuale completata
  const [processedCount, setProcessedCount] = useState(0); // File processati
  const [totalFiles, setTotalFiles] = useState(0); // Totale file da processare
  const [debugMessages, setDebugMessages] = useState([]); // Messaggi di debug

  const handleIngest = () => {
    setIngestStatus("inProgress");
    setProgress(0);
    setProcessedCount(0);
    setDebugMessages(["Inizio del processo di ingest..."]);

    // Seleziona l'URL corretto a seconda della modalità
    let url = `${globals.homepageUrl}/php/ingest.php?action=ingest&watermark=${watermark}`;

    // Modalità integrata con recupero sessione
    if (mode === "integrated") {
      const reuse = window.confirm("Vuoi recuperare la sessione precedente?");
      const reuseParam = reuse ? "true" : "false";
      url = `${globals.homepageUrl}/php/ingest.php?action=ingest_with_session&reuseLastSession=${reuseParam}&watermark=${watermark}`;
    }

    // Configura EventSource per ricevere aggiornamenti dal server
    const eventSource = new EventSource(url);

    // Quando riceve un messaggio dal server
    eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);

        if (data.totalFiles !== undefined) {
          setTotalFiles(data.totalFiles); // Aggiorna il totale dei file
          setDebugMessages((prevMessages) => [
            ...prevMessages,
            `Totale file da elaborare: ${data.totalFiles}`,
          ]);
        }

        // Gestisci aggiornamenti progressivi
        if (data.progress !== undefined) {
          setProcessedCount((prev) => prev + 1);
          setProgress(data.progress); // Aggiorna la barra di progresso
          setDebugMessages((prevMessages) => [
            ...prevMessages,
            `File elaborato: ${data.file} - Progresso: ${data.progress}%`,
          ]);
        }

        // Completamento
        if (data.status === "success") {
          setIngestStatus("success");
          setDebugMessages((prevMessages) => [
            ...prevMessages,
            "Ingest completato con successo!",
          ]);
          eventSource.close(); // Chiudi la connessione
        }

        // Errori di elaborazione specifici
        if (data.status === "error") {
          setIngestStatus("error");
          setDebugMessages((prevMessages) => [
            ...prevMessages,
            `Errore: ${data.message}`,
          ]);
          eventSource.close(); // Chiudi la connessione
        }
      } catch (error) {
        setDebugMessages((prevMessages) => [
          ...prevMessages,
          `Errore di parsing del messaggio: ${event.data}`,
        ]);
      }
    };

    // Quando si verifica un errore di connessione
    eventSource.onerror = () => {
      setIngestStatus("error");
      setDebugMessages((prevMessages) => [
        ...prevMessages,
        "Errore durante lo streaming dei dati.",
      ]);
      eventSource.close();
    };
  };

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        padding: "20px",
        maxWidth: "600px",
        margin: "0 auto",
        minHeight: "800px",
      }}
    >
      <h1 style={{ textAlign: "center", color: "#444" }}>Esegui Ingest</h1>

      {/* Selezione modalità ingest */}
      <div style={{ margin: "20px" }}>
        <label style={{ marginRight: "10px", fontWeight: "bold" }}>Modalità:</label>
        <select style={{fontSize:'16px'}} value={mode} onChange={(e) => setMode(e.target.value)}>
          <option  value="normal">One Folder per Day</option>
          <option  value="integrated">MultiDay to One Folder</option>
        </select>
      </div>

      {/* Selezione watermark */}
      <div style={{ margin: "20px" }}>
        <label style={{ marginRight: "10px", fontWeight: "bold" }}>Watermark:</label>
        <select style={{fontSize:'16px'}} value={watermark} onChange={(e) => setWatermark(e.target.value)}>
          <option  value={"true"}>Yes</option>
          <option  value={"false"}>No</option>
        </select>
      </div>

      {/* Pulsante per avviare ingest */}
      <button
        onClick={handleIngest}
        style={{
          display: "block",
          width: "100%",
          padding: "12px",
          backgroundColor:
            ingestStatus === "success"
              ? "#28a745"
              : ingestStatus === "error"
              ? "#dc3545"
              : "#0066CC",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontSize: "16px",
          marginBottom: "20px",
          transition: "background-color 0.3s",
        }}
      >
        {ingestStatus === "success"
          ? "Ingest Completato!"
          : ingestStatus === "error"
          ? "Errore!"
          : "Esegui Ingest"}
      </button>

      {/* Barra di Progresso */}
      <div style={{ margin: "20px 0" }}>
        <div
          style={{
            height: "20px",
            width: "100%",
            backgroundColor: "#e0e0e0",
            borderRadius: "5px",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <div
            style={{
              height: "100%",
              width: `${progress}%`,
              backgroundColor: "#28a745",
              transition: "width 0.3s ease",
            }}
          ></div>
        </div>
        <p style={{ textAlign: "center", marginTop: "5px", color: "#444" }}>
          {processedCount} di {totalFiles} file elaborati ({Math.round(progress)}%)
        </p>
      </div>

      {/* Messaggi di Debug */}
      <div style={{ marginTop: "20px", color: "#444", fontSize: "14px" }}>
        {debugMessages.map((message, index) => (
          <p key={index} style={{ marginBottom: "5px" }}>
            {message}
          </p>
        ))}
      </div>
    </div>
  );
};

export default Ingest;
